<template lang="pug">
.form-price.center(:class="{'inside-padding': !fillData}")
  h2.title {{ title }}

  .observations-container(v-if="fillData")
    .observation.list-items.dark(v-if="dataForm.observations && dataForm.observations.length")
      .observation-observation Observation
      .observation-type Type
      .observation-created-at Created At
      .observation-created-by Created By
    .observation.list-items(v-for="(observation, index) in dataForm.observations" :key="observation.createdAt" v-if="observation")
      .observation-observation {{ index + 1 }}. {{ observation.observation }}
      .observation-type {{ observation.type }}
      .observation-created-at {{ dateTime(observation.createdAt) }}
      shNameUser.observation-created-by(:dni="observation.createdBy")

  form(v-if="fillData" @submit.prevent="")
    .input-container
      textarea.input(v-model="observation.observation" autocomplete="ño" rows="3" required)
      label.label Observación

    .input-container.arrow.arrow-icon
      select.select(v-model="observation.type" autocomplete="ño" required)
        option(value="" select)
        option(value="delivery") Entrega
        option(value="pay") Pago
        option(value="product") Producto
        option(value="support") Soporte
      label.label(:class="{ show: observation.type }") Tipo

    shActionButton(:isForm="true" :action="addObservation" text="Agregar Observación" textRunning="Agregando Observación")

  .form-section(v-if="!fillData")
    .input-container
      input.input(v-model="name" @keydown.enter="findUser" autocomplete="ño")
      label.label(:class="{ show: name }") Buscar Usuario

    .users-list
      div(v-for="(user, index) in wholesalerUsers")
        shActionButton.capitalize(:action="chooseWholesaler" :params="[index]" :text="`${user.name} - ${user.type}`" :textRunning="`${user.name} - ${user.type}`")

  .divider

  form(@submit.prevent="")
    .form-section
      .input-container(v-if="dataForm.isWholesaler")
        input.input(v-model="dataForm.isWholesaler" autocomplete="ño" :disabled="true" required)
        label.label(:class="{ show: dataForm.isWholesaler !== '' }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="isWholesaler" title="Mayorista")

      .input-container(v-if="dataForm.isDropshipping")
        input.input(v-model="dataForm.isDropshipping" autocomplete="ño" :disabled="true" required)
        label.label(:class="{ show: dataForm.isDropshipping !== '' }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="isDropshipping" title="Dropshipping")

      .input-container(v-if="dataForm.dniDropshippingUser")
        input.input(v-model="dataForm.dniDropshippingUser" autocomplete="ño" :disabled="true" required)
        label.label(:class="{ show: dataForm.dniDropshippingUser }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="dniDropshippingUser" title="Identificación Dropshipping")

    .form-section
      .input-container
        input.input(v-model="dataForm.dni" autocomplete="ño")
        label.label(:class="{ show: dataForm.dni }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="dni" title="Identificación")

      .input-container
        input.input(v-model="dataForm.name" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.name }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="name" title="Nombre")

      .input-container
        textarea.input(v-model="dataForm.address" autocomplete="ño" rows="5" required)
        label.label(:class="{ show: dataForm.address }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="address" title="Dirección")

    .divider

    .form-section
      .input-container
        input.input(v-model="dataForm.phones[0]" pattern="[0-9]{10}" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.phones[0] }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="phones" :index="0" title="Teléfono")

      .input-container
        input.input(v-model="dataForm.email" type="email" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.email }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="email" title="Email")

    .divider

    .form-section
      .input-container
        input.input(v-model="dataForm.location" @input="findLocation" @focus="dataForm.location = ''; dataForm.department = ''" @blur="dataForm.location = ''; dataForm.department = ''" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.location }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="location" title="Ubicación")

        .locations-x(v-if="locations.length")
          div(v-for="(location, index) in locations")
            shActionButton.capitalize(:action="chooseLocation" :params="[index]" :text="`${location.location} - ${location.department}`" :textRunning="`${location.location} - ${location.department}`")

      .input-container(v-if="dataForm.department")
        input.input(v-model="dataForm.department" disabled autocomplete="ño" required)
        label.label(:class="{ show: dataForm.department }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="department" title="Departmento")

    .divider

    .input-container.arrow
      select.select(v-model="dataForm.brand" :disabled="fillData"  autocomplete="ño" required)
        option(value="")
        option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
      label.label(:class="{ show: dataForm.brand }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="brand" title="Marca")

    .input-container.arrow
      select.select(v-model="dataForm.listPrice" autocomplete="ño" @focus="getPrices" @change="setPrices" required)
        option(value="")
        option(v-for="listPrice in listPrices" :value="listPrice.price") {{ listPrice.price }}
      label.label(:class="{ show: dataForm.listPrice }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="listPrice" title="Lista de Precios")

    .divider

    .input-container
      select.select(v-model="dataForm.methodPay" autocomplete="ño" :disabled="dataForm.isDropshipping === true" required)
        option(value="")
        option(v-for="methodPay in methodsPay" :value="methodPay") {{ methodPay }}
      label.label(:class="{ show: dataForm.methodPay }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="methodPay" title="Método de Pago")

    .input-container.arrow
      select.select(v-model="dataForm.conveyor" autocomplete="ño" required)
        option(v-for="conveyor in conveyors" :value="conveyor") {{ capitalize(conveyor) }}
      label.label(:class="{ show: dataForm.conveyor }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyor" title="Transportadora")

    .input-container
      input.input(v-model.number="dataForm.conveyorCost" autocomplete="ño" required)
      label.label(:class="{ show: dataForm.conveyorCost >= 0 }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyorCost" title="Costo de la Transportadora")

    .input-container.arrow
      label.label(:class="{ show: typeof dataForm.userPayConveyor === 'boolean' }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="userPayConveyor" title="Envío al cobro")
      select.select(v-model="dataForm.userPayConveyor" autocomplete="ño")
        option(:value="true" selected) Sí
        option(:value="false") No

    shActionButton(:isForm="true" :action="sendForm" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'")

  div(v-if="fillData")
    .input-container
      input.input(v-model="code" @keydown.enter="processCode()" autocomplete="ño")
      label.label(:class="{ show: code }") Ingresar Código

  div(v-if="fillData" :class="{'color-red': error}") Error: {{ error }}

  div(v-if="fillData")
    .product-x(v-for="product in dataForm.cart")
      h3.uppercase {{ product.product }}
      img.image-x(:src="`${imagePath}/${dataForm.brand}/${product.folder}${ product.subfolder ? `/${product.subfolder}` : ''}/${product.images[0]}`")
      div
        div(v-for="(size, index) in product.sizes" v-if="product.quantityCart[index]")
          .sizes-x
            .uppercase {{ size }}
            div {{ product.quantityCart[index] }}
            div(v-for="tier in product.tiers[index]")
              shActionButton(v-if="fillData" :action="subtractProduct" :params="[product.product, size, tier]" :text="tier" :textRunning="tier")
      div Normal: {{ money(product.priceWholesaler) }}
      div Nuevo: {{ prices && prices[product.person] && prices[product.person][product.article] && prices[product.person][product.article][product.design] ? money(prices[product.person][product.article][product.design]) : '$ 0' }}

  shActionButton.button-update-prices(v-if="fillData" :action="updatePrices" text="Actualizar Precios" textRunning="Actualizando Precios")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlOrderWholesaler from '@/graphql/orderWholesaler'
import gqlUser from '@/graphql/user'
import gqlPrice from '@/graphql/price'
import gqlOrder from '@/graphql/order'
import gqlLocation from '@/graphql/location'
import shInputList from '@/components/elements/InputList'
import modals from '@my/store/modals'
import shNameUser from '@/components/elements/NameUser'
import { normalizeScanCode, stripScanPrefix } from '@/helpers/scanCode'

export default {
  name: 'FormPrice',

  mixins: [mForm, mFilters, mDB],

  components: { shInputList, shNameUser },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      code: '',
      currentTier: 't0',
      sounds: {
        beepError: 'beep_error.mp3',
        beep: 'beep.mp3',
        error: 'error.mp3',
        tier: 'tier.mp3',
        product: 'product.mp3',
        subtracted: 'subtracted.mp3',
        noTier: 'no_tier.mp3'
      },
      audios: {
        beepError: '',
        beep: '',
        error: '',
        tier: '',
        product: '',
        subtracted: '',
        noTier: ''
      },
      dataForm: {
        dni: '',
        name: '',
        phones: [''],
        address: '',
        email: '',
        location: '',
        department: '',
        isDropshipping: false,
        isWholesaler: false,
        listPrice: '',
        methodPay: '',
        dniDropshippingUser: '',
        userPayConveyor: false,
        brand: ''
      },
      observation: {
        observation: '',
        type: ''
      },
      name: '',
      error: '',
      wholesalerUsers: [],
      locations: [],
      listPrices: [],
      prices: {},
      resolver: 'orderWholesaler',
      key: 'order',
      gql: gqlOrderWholesaler,
      methodsPay: ['credit', 'dropshipping', 'nequi', 'daviplata', 'movii', 'bancolombia', 'cod', 'ahorro', 'factory', 'efecty', 'baloto', 'visa', 'mastercard', 'codensa', 'amex', 'pse', 'cash'],
      delete: ['order', 'cart', 'createdAt', 'updatedAt', 'declinedAt', 'declinedBy', 'approvedAt', 'approvedBy', 'paidAt', 'paidBy', 'sentAt', 'sentBy', 'packedAt', 'packedBy', 'deliveryTracking', 'payManual', 'observations', 'collectedAt', 'collectedBy', 'collectedValue', 'observations', 'deliveries', 'refund']
    }
  },

  created () {
    if (this.fillData) {
      this.dataForm = this.copyObject(this.dataOriginal)
    }
  },

  async mounted () {
    if (this.fillData) {
      await this.getPrices()
      this.setPrices()
    }
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newOrderWholesaler()
      } else {
        this.updateOrderWholesaler()
      }
    },

    newOrderWholesaler () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateOrderWholesaler () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteOrderWholesaler () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    processCode () {
      const code = normalizeScanCode(this.code)
      const tier = this.currentTier.toLowerCase()

      if (!code) {
        this.playSoundError()
        return
      }

      if (code[0] === '-') {
        const tier = stripScanPrefix(code)
        if (tier) {
          this.setTier(tier)
        } else {
          this.playSoundError()
        }
      } else {
        if (!tier) {
          this.playSoundNoTier()
        } else {
          const productSplit = code.split('-')

          if (productSplit.length !== 2) {
            this.playSoundError()
          } else {
            const nameProduct = productSplit[0]
            const size = productSplit[1]

            if (nameProduct && size && tier) {
              this.addProduct(nameProduct.toLowerCase().trim(), size.toLowerCase().trim(), tier.toLowerCase().trim())
            } else {
              this.playSoundError()
            }
          }
        }
      }

      this.code = ''
    },

    setTier (tier) {
      this.currentTier = tier
      this.playSoundTier()
    },

    async addProduct (product, size, tier) {
      const mutation = gqlOrder.ADD_PRODUCT
      const options = { order: this.dataForm.order, product, size, quantity: 1, tier }

      const response = await gql.mutate(mutation, options, false)

      if (response.error) {
        this.error = response.error
        this.playSoundError()
        return
      }

      if (response && response.data && response.data.addProductOrder) {
        this.error = ''
        this.playSoundProduct()
      }
    },

    async subtractProduct (product, size, tier) {
      const mutation = gqlOrder.SUBTRACT_PRODUCT
      const options = { order: this.dataForm.order, product, size, quantity: 1, tier }

      const response = await gql.mutate(mutation, options, false)

      if (response.error) {
        this.error = response.error
        this.playSoundError()
        return
      }

      if (response && response.data && response.data.subtractProductOrder) {
        this.error = ''
        this.playSoundSubtracted()
      }
    },

    async updatePrices () {
      const mutation = gqlOrderWholesaler.UPDATE_PRICES
      const options = { order: this.dataForm.order, price: this.dataForm.listPrice }

      console.log(options)

      const response = await gql.mutate(mutation, options)

      if (response && response.data && response.data.updatePricesOrderWholesaler) {
        modals.showMessage({ message: `Se cambiaron los precios correntamente` })
      }
    },

    playSoundTier () {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.tier) {
        this.audios.tier = this.playSound(this.sounds.tier)
      } else {
        this.audios.tier.play()
      }
    },

    playSoundNoTier () {
      if (!this.audios.beepError) {
        this.audios.beepError = this.playSound(this.sounds.beepError)
      } else {
        this.audios.beepError.play()
      }

      if (!this.audios.noTier) {
        this.audios.noTier = this.playSound(this.sounds.noTier)
      } else {
        this.audios.noTier.play()
      }
    },

    playSoundProduct () {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.product) {
        this.audios.product = this.playSound(this.sounds.product)
      } else {
        this.audios.product.play()
      }
    },

    playSoundSubtracted () {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.subtracted) {
        this.audios.subtracted = this.playSound(this.sounds.subtracted)
      } else {
        this.audios.subtracted.play()
      }
    },

    playSoundError () {
      if (!this.audios.beepError) {
        this.audios.beepError = this.playSound(this.sounds.beepError)
      } else {
        this.audios.beepError.play()
      }

      if (!this.audios.error) {
        this.audios.error = this.playSound(this.sounds.error)
      } else {
        this.audios.error.play()
      }
    },

    deleteProduct (productName) {
      this.$delete(this.stock, productName)
    },

    async findUser () {
      if (!this.name) return

      const query = gqlUser.GET_WHOLESALER_BY_NAME

      const response = await gql.query(query, { name: this.name })

      if (response && response.data && response.data.getWholesalerByName) this.wholesalerUsers = response.data.getWholesalerByName
    },

    chooseWholesaler (index) {
      const user = this.wholesalerUsers[index]

      if (user.type === 'dropshipping') {
        this.dataForm.dniDropshippingUser = user.dni
        this.dataForm.dni = ''
        this.dataForm.phones[0] = ''
        this.dataForm.email = ''
        this.dataForm.name = ''
        this.dataForm.address = ''
        this.dataForm.isDropshipping = true
        this.dataForm.isWholesaler = false
      } else {
        this.dataForm.dniDropshippingUser = ''
        this.dataForm.dni = user.dni
        this.dataForm.phones[0] = user.phones[0]
        this.dataForm.email = user.emails[0]
        this.dataForm.name = user.name
        this.dataForm.address = user.addresses[0]
        this.dataForm.isDropshipping = false
        this.dataForm.isWholesaler = true
      }
      this.wholesalerUsers = []
    },

    async findLocation () {
      if (!this.dataForm.location) return
      if (this.dataForm.location.length < 2) return

      const query = gqlLocation.GET_BY_NAME

      const response = await gql.query(query, { startsWith: this.dataForm.location })

      if (response && response.data && response.data.getLocationsEcommerce) this.locations = response.data.getLocationsEcommerce
    },

    chooseLocation (index) {
      const location = this.locations[index]

      this.dataForm.location = location.location
      this.dataForm.department = location.department

      this.locations = []
    },

    async getPrices () {
      const query = gqlPrice.GET_ALL

      const response = await gql.query(query, {})

      if (response && response.data && response.data.getPrices && response.data.getPrices.docs) {
        this.listPrices = response.data.getPrices.docs
      }
    },

    setPrices () {
      const listPriceIndex = this.listPrices.findIndex(listPrice => listPrice.price === this.dataForm.listPrice)

      if (listPriceIndex < 0) {
        this.prices = {}
      } else {
        this.prices = JSON.parse(this.listPrices[listPriceIndex].stringPrice)
      }
    },

    async addObservation () {
      const mutation = gqlOrder.ADD_OBSERVATION
      const order = this.dataForm.order

      const response = await gql.mutate(mutation, { order, observation: this.observation.observation, type: this.observation.type })

      if (response) {
        modals.showMessage({ message: 'Observación agregada' })
        this.observation.observation = ''
        this.observation.type = ''
      }
    }
  },

  computed: {
    conveyors () {
      return this.$store.state.variables.conveyors
    },
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'
@import '~@/stylus/variables.styl'

.form-price
  position relative

.locations-x
  display inline-flex
  gap 1em
  flex-wrap wrap
  margin 1em

.sizes-x
  display flex
  gap 1em
  flex-wrap wrap
  margin 1em 0
  align-items center

.image-x
  width 15em

.product-x
  display flex
  gap 1em
  flex-wrap wrap
  margin 1em
  align-items center

.tier-x
  border-radius 50%
  border 1px solid principal-color
  width 2em
  height 2em
  display inline-flex
  align-items center
  justify-content center
  cursor pointer

.observation
  display flex
  justify-content space-between

.observation-observation
  flex-basis 40%
  text-align left

.observation-type
  flex-basis 20%

.observation-created-at
  flex-basis 20%

.observation-created-by
  flex-basis 20%
  text-align right

.users-list
  display flex
  justify-content center
  gap 1em

.button-update-prices
  margin-top 2em
</style>



// WEBPACK FOOTER //
// src/components/pages/orderWholesaler/Form.vue